module.exports = __webpack_public_path__ + "static/media/babySkinHairCare.1126705f.webp";